import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=5c0ec016"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports